import { useState } from 'react';
import { logEvent } from '@amplitude/analytics-browser';
import Box from '@mui/material/Box';
import Typography from '../../../componentsv2/Typography';
import Button from '../../../componentsv2/Button';
import StepButtons from './StepButtons';
import SATHelpDrawer from '../../../componentsv2/SATHelpDrawer';
import { ArrowRightIcon, SecuritySATSafeIcon } from '../../../components/Icons';
import { useTranslation } from '../../../hooks/i18n';
import { COLORS } from '../../../themev2';
import { SATEvents } from '../../../constants/events';

interface ConnectSATProps {
  onConnect: () => void;
  onBack: () => void;
  isLoading?: boolean;
}

const ConnectSAT = ({ onConnect, onBack, isLoading }: ConnectSATProps) => {
  const { t } = useTranslation(['activation', 'application']);
  const [openDrawer, setOpenDrawer] = useState(false);

  const handleOpenSATHelp = () => {
    setOpenDrawer(true);
    logEvent(SATEvents.OPEN_SAT_HELP);
  };

  const handleCloseSATHelp = () => {
    setOpenDrawer(false);
    logEvent(SATEvents.CLOSE_SAT_HELP);
  };

  return (
    <>
      <SATHelpDrawer open={openDrawer} onClose={handleCloseSATHelp} />

      <Box sx={{ display: 'flex', flexDirection: 'column', flex: 1 }}>
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: '8px', mb: 4 }}>
          <Typography
            sx={{ fontWeight: 600, fontSize: '24px', lineHeight: '36px', color: COLORS.brand.night }}
          >
            {t('activation:step2.title')}
          </Typography>
          <Typography
            sx={{ fontSize: '18px', fontWeight: 400, lineHeight: '27px', color: COLORS.gray[1100] }}
          >
            {t('activation:connectSAT.subtitle')}
          </Typography>
        </Box>

        <Box
          sx={{
            display: 'flex',
            alignItems: 'flex-start',
            gap: '12px',
            borderLeft: `3px solid ${COLORS.gray[400]}`,
            pl: 2,
            py: 1,
            mb: 4,
          }}
        >
          <Box sx={{ color: COLORS.secondary.indigo, flexShrink: 0, mt: '2px' }}>
            <SecuritySATSafeIcon />
          </Box>
          <Box>
            <Typography sx={{ fontWeight: 600, fontSize: '14px', color: COLORS.brand.night }}>
              {t('activation:connectSAT.secureTitle')}
            </Typography>
            <Typography sx={{ fontSize: '13px', color: COLORS.gray[1100], mt: '4px' }}>
              {t('connectSAT.secureDescription1')}
              <br />
              {t('connectSAT.secureDescription2')}
            </Typography>
          </Box>
        </Box>

        <Box sx={{ mb: 2, display: 'flex', flexDirection: 'column', gap: '12px', alignItems: 'flex-start' }}>
          <Button
            color="secondary"
            onClick={onConnect}
            isLoading={isLoading}
            endIcon={<ArrowRightIcon />}
            isFullHeight={false}
          >
            {t('activation:connectSAT.connectButton')}
          </Button>
          <Button type="link" onClick={handleOpenSATHelp} color="secondary">
            {t('application:sections.taxInformation.whyConnectSAT')}
          </Button>
        </Box>

        <StepButtons onBack={onBack} onNext={onConnect} isNextLoading={isLoading} />
      </Box>
    </>
  );
};

export default ConnectSAT;
